import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Button from 'Components/Button';
import WhatsAppService from 'Services/Http/WhatsApp.service';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';

const ListarMensajesComponente = () => {
  const [otps, setOtps] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pageActive, setPageActive] = useState(0);
  useEffect(() => {
    getlastOtps();
  }, []);

  const getlastOtps = async (page) => {
    setLoader(true);
    setOtps([]);
    setPageActive(page);
    const response = await WhatsAppService.getStatusMessage({ page });
    createRows(response.data);
    setLoader(false);
  };

  const replaceText = (text) => {
    let newText;
    switch (text) {
      case 'sent':
        newText = 'Enviado';
        break;
      case 'delivered':
        newText = 'Entregado';
        break;
      case 'read':
        newText = 'Leido';
        break;
      case 'failed':
        newText = 'Fallido';
        break;
      default:
        newText = text;
        break;
    }
    return newText;
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'otps-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4">{index + 1}</td>
        <td className="px-6 py-4">{item.id}</td>
        <td className="px-6 py-4">{item.telefono}</td>
        <td className="px-3 py-4 w-2/5" dangerouslySetInnerHTML={{ __html: item.text }}></td>
        <td className="px-6 py-4">{replaceText(item.status)}</td>
        <td className="px-6 py-4">{item.error}</td>
        <td className="px-6 py-4">{moment(item.created_at).format('DD/MM/YYYY hh:mm:ss a')}</td>
      </tr>
    ));
    setOtps(data);
  };
  const refresh = () => {
    getlastOtps(pageActive);
  };
  return (
    <>
      <Label text={'Lista de Mensajes'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <Button iconprefix={['fa', 'rotate']} onClick={() => refresh()} />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Id
              </th>
              <th scope="col" className="px-6 py-3">
                Numero mov&iacute;l
              </th>
              <th scope="col" className="px-6 py-3">
                Mensaje enviado
              </th>
              <th scope="col" className="px-6 py-3">
                Estatus
              </th>
              <th scope="col" className="px-6 py-3">
                Error
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha y hora de env&iacute;o
              </th>
            </tr>
          </thead>
          <tbody>{otps}</tbody>
          <tfoot>
            <tr>
              <td colSpan={8}>
                <Paginador onChange={getlastOtps} />
              </td>
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarMensajesComponente;
